import React, { JSX } from 'react';
import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import { Box, TableCell, TableHead, TableRow } from '@mui/material';
import { SortDirection, SortField } from './documentListUtils';

interface HeaderCellProps {
  field: SortField;
  label: string;
  sortField: SortField | null;
  sortDirection: SortDirection;
  width?: string;
  align?: 'left' | 'center';
  onSort: (field: SortField) => void;
}

interface DocumentListHeaderProps {
  isMobile: boolean;
  sortField: SortField | null;
  sortDirection: SortDirection;
  onSort: (field: SortField) => void;
}

function SortIcon(props: {
  field: SortField;
  sortField: SortField | null;
  sortDirection: SortDirection;
}): JSX.Element | null {
  if (props.sortField !== props.field) return null;
  const Icon = props.sortDirection === 'asc' ? ArrowUpward : ArrowDownward;
  return <Icon fontSize="small" sx={{ ml: 0.5 }} />;
}

function HeaderCell(props: HeaderCellProps): JSX.Element {
  const { field, label, sortField, sortDirection, width, align = 'left', onSort } = props;

  return (
    <TableCell
      sx={{
        fontWeight: 600,
        width,
        textAlign: align,
        cursor: 'pointer',
        userSelect: 'none',
        '&:hover': { backgroundColor: 'action.hover' },
      }}
      onClick={() => onSort(field)}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: align === 'center' ? 'center' : 'flex-start',
        }}
      >
        {label}
        <SortIcon field={field} sortField={sortField} sortDirection={sortDirection} />
      </Box>
    </TableCell>
  );
}

export function DocumentListHeader(props: DocumentListHeaderProps): JSX.Element {
  const { isMobile, sortField, sortDirection, onSort } = props;

  return (
    <TableHead>
      <TableRow>
        <HeaderCell
          field="name"
          label="Name"
          sortField={sortField}
          sortDirection={sortDirection}
          onSort={onSort}
        />
        {!isMobile && (
          <HeaderCell
            field="type"
            label="Type"
            width="80px"
            sortField={sortField}
            sortDirection={sortDirection}
            onSort={onSort}
          />
        )}
        {!isMobile && (
          <HeaderCell
            field="size"
            label="Size"
            width="80px"
            sortField={sortField}
            sortDirection={sortDirection}
            onSort={onSort}
          />
        )}
        {!isMobile && (
          <HeaderCell
            field="date"
            label="Date"
            width="100px"
            sortField={sortField}
            sortDirection={sortDirection}
            onSort={onSort}
          />
        )}
        <HeaderCell
          field="rag"
          label="RAG"
          width="80px"
          align="center"
          sortField={sortField}
          sortDirection={sortDirection}
          onSort={onSort}
        />
        <TableCell sx={{ fontWeight: 600, width: '120px', textAlign: 'center' }}>Actions</TableCell>
      </TableRow>
    </TableHead>
  );
}
